// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.drawer .menu-item span {
  display: inline; /* Montrer le texte en mode étendu */
  overflow: hidden;
  white-space: nowrap;
}
.drawer .menu-item span,
.drawer .h6,
.drawer .reduced-hide {
  transition: opacity 0.3s, max-width 0.3s;
  opacity: 1;
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
}

#___ytsubscribe_0 iframe {
  max-width: 110px !important;
}

:host ::ng-deep p-button .p-button {
  width: 100%;
}

.separator {
  height: 1px;
  width: calc(100% - 3rem);
  background: var(--surface-200);
  margin: 0.5rem 1.5rem;
  display: block;
}

.toggle-button {
  position: absolute;
  top: 1rem;
  right: -1rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  z-index: 100;
  background: var(--surface-300);
  border-radius: 8px;
  padding: 0.5rem;
}

a {
  text-decoration: none;
  color: var(--text-color);
}
a:hover {
  color: var(--primary-color);
  font-weight: bold;
}

#___ytsubscribe_0 {
  text-indent: 0px;
  margin: 0px;
  padding: 0px;
  background: transparent;
  border-style: none;
  float: none;
  line-height: normal;
  font-size: 1px;
  vertical-align: baseline;
  display: inline-block;
  width: 110px;
  height: 24px;
  border-radius: 2px;
}
#___ytsubscribe_0 iframe {
  margin-inline: auto;
  border-radius: 2px;
  position: static;
  top: 0px;
  width: 110px;
  margin: 0px;
  border-style: none;
  left: 0px;
  visibility: visible;
  height: 24px;
  background: var(--surface-ground);
}

.menu-item {
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  display: flex;
  align-items: center;
  line-height: 1.4;
}

.menu-item:hover {
  background-color: var(--surface-100);
}

.menu-item i {
  font-size: 1.2rem;
}

.menu-item span {
  font-size: 1rem;
}

h4,
h5 {
  font-weight: bold;
  color: var(--text-color-secondary);
}

.used-capacity-section {
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 0.5rem;
}

app-image {
  display: block;
  margin: 0 auto;
  width: 3rem;
  height: 3rem;
}

.overflow-auto {
  position: relative;
  overflow-x: hidden !important;
}
.overflow-auto + * {
  position: relative;
}
.overflow-auto + *:after {
  content: "";
  position: absolute;
  right: 0;
  top: -4rem;
  width: 100%;
  height: 4rem;
  box-shadow: 0px -8px 4px -4px rgba(0, 0, 0, 0.15) inset;
}

.logout {
  display: grid;
  place-content: center;
  margin-left: 1rem;
}

.profile-container {
  min-width: 0;
}

.profile-infos {
  flex: 1 2 0%;
  min-width: 0;
}
.profile-infos > * {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

p,
.h6 {
  text-overflow: ellipsis;
}

.youtube-container > div:first-child *:last-child {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/logged-drawer/logged-drawer.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,eAAA,EAAA,oCAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;;;EAGE,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAKE;EACE,2BAAA;AAFJ;;AAOE;EACE,WAAA;AAJJ;;AAQA;EACE,WAAA;EACA,wBAAA;EACA,8BAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AALF;;AAQA;EACE,qBAAA;EACA,wBAAA;AALF;AAOE;EACE,2BAAA;EACA,iBAAA;AALJ;;AASA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AANF;AAQE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;AANJ;;AAUA;EACE,eAAA;EACA,6CAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;;EAEE,iBAAA;EACA,kCAAA;AAPF;;AAUA;EACE,mBAAA;EACA,aAAA;EACA,qBAAA;AAPF;;AAUA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,kBAAA;EACA,6BAAA;AAPF;AASE;EACE,kBAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;AAPN;;AAYA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;AATF;;AAYA;EACE,YAAA;AATF;;AAYA;EACE,YAAA;EACA,YAAA;AATF;AAWE;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AATJ;;AAaA;;EAEE,uBAAA;AAVF;;AAeI;EACE,cAAA;AAZN","sourcesContent":[".drawer {\r\n  .menu-item span {\r\n    display: inline; /* Montrer le texte en mode étendu */\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .menu-item span,\r\n  .h6,\r\n  .reduced-hide {\r\n    transition: opacity 0.3s, max-width 0.3s;\r\n    opacity: 1;\r\n    max-width: 280px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n#___ytsubscribe_0 {\r\n  iframe {\r\n    max-width: 110px !important;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  p-button .p-button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.separator {\r\n  height: 1px;\r\n  width: calc(100% - 3rem);\r\n  background: var(--surface-200);\r\n  margin: 0.5rem 1.5rem;\r\n  display: block;\r\n}\r\n\r\n.toggle-button {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: -1rem;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  cursor: pointer;\r\n  z-index: 100;\r\n  background: var(--surface-300);\r\n  border-radius: 8px;\r\n  padding: 0.5rem;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: var(--text-color);\r\n\r\n  &:hover {\r\n    color: var(--primary-color);\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n#___ytsubscribe_0 {\r\n  text-indent: 0px;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  background: transparent;\r\n  border-style: none;\r\n  float: none;\r\n  line-height: normal;\r\n  font-size: 1px;\r\n  vertical-align: baseline;\r\n  display: inline-block;\r\n  width: 110px;\r\n  height: 24px;\r\n  border-radius: 2px;\r\n\r\n  iframe {\r\n    margin-inline: auto;\r\n    border-radius: 2px;\r\n    position: static;\r\n    top: 0px;\r\n    width: 110px;\r\n    margin: 0px;\r\n    border-style: none;\r\n    left: 0px;\r\n    visibility: visible;\r\n    height: 24px;\r\n    background: var(--surface-ground);\r\n  }\r\n}\r\n\r\n.menu-item {\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, color 0.3s;\r\n  padding: 0.5rem 0.5rem 0.5rem 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  line-height: 1.4;\r\n}\r\n\r\n.menu-item:hover {\r\n  background-color: var(--surface-100);\r\n}\r\n\r\n.menu-item i {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.menu-item span {\r\n  font-size: 1rem;\r\n}\r\n\r\nh4,\r\nh5 {\r\n  font-weight: bold;\r\n  color: var(--text-color-secondary);\r\n}\r\n\r\n.used-capacity-section {\r\n  background: #f9f9f9;\r\n  padding: 1rem;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\napp-image {\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 3rem;\r\n  height: 3rem;\r\n}\r\n\r\n.overflow-auto {\r\n  position: relative;\r\n  overflow-x: hidden !important;\r\n\r\n  & + * {\r\n    position: relative;\r\n\r\n    &:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      right: 0;\r\n      top: -4rem;\r\n      width: 100%;\r\n      height: 4rem;\r\n      box-shadow: 0px -8px 4px -4px rgba(0, 0, 0, 0.15) inset;\r\n    }\r\n  }\r\n}\r\n\r\n.logout {\r\n  display: grid;\r\n  place-content: center;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.profile-container {\r\n  min-width: 0;\r\n}\r\n\r\n.profile-infos {\r\n  flex: 1 2 0%;\r\n  min-width: 0;\r\n\r\n  > * {\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\np,\r\n.h6 {\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.youtube-container {\r\n  > div:first-child {\r\n    *:last-child {\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
